module.exports = __webpack_public_path__ + "static/media/restricted-regions-logo-popover.5d36e85d.svg";